var _circle, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLoadMadkudu = function SvgLoadMadkudu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.8 42.8"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.4,
    cy: 21.4,
    r: 20,
    fill: "none",
    stroke: "#131F40",
    strokeWidth: 3,
    opacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#131F40",
    strokeWidth: 3,
    d: "M41.4 21.4c0-8.2-4.9-15.3-12-18.3"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    begin: 0,
    dur: "0.6s",
    from: "0 21.4 21.4",
    repeatCount: "indefinite",
    to: "360 21.4 21.4",
    type: "rotate"
  }), "/>")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#131F40",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.66 15.018c-.044.1-.163.195-.376.318l-.016.008c-.26.115-.459.255-.505.354-.01.02-.009.023.012.045.054.056.179.116.386.172.615.196 1.571.88 2.375 1.719.96 1.003 1.61 2.105 1.751 3.131.203 1.012.025 2.19-.43 3.432l-.01.028.04.014a6.783 6.783 0 0 1 2.915 1.986l.07.082c.703.823 1.253 1.75 2.08 3.391h-2.55c-.252-.897-.902-1.58-1.8-2.259-.527-.389-1.015-.532-2.172-.725h-.004c-.782-.131-1.129-.208-1.544-.369l-.022-.008-.019-.015c-.522-.399-.621-.878-.358-1.373.181-.34.49-.64.973-1.016 1.335-1.191 1.316-3.535.097-5.045-.62-.826-1.839-1.504-3.222-2.006l-.035-.013-.027-.028c-.356-.365-.348-.776-.039-1.143.23-.273.626-.521 1.1-.718.4-.166.816-.277 1.047-.28.208-.003.382.09.282.318M30.518 14.7c.241.003.676.11 1.093.27.495.19.908.429 1.149.693.323.353.33.749-.04 1.101l-.029.027-.037.013c-1.443.483-2.716 1.138-3.368 1.938-1.269 1.452-1.289 3.712.097 4.854.514.37.835.66 1.024.987.275.477.171.94-.374 1.324l-.02.014-.023.008c-.433.156-.796.23-1.612.355h-.004c-1.208.187-1.718.325-2.267.699-.938.656-1.617 1.73-1.88 2.595l-.036.12-.131.001H21.5c.863-1.584 1.502-3.013 2.236-3.806a7.136 7.136 0 0 1 3.118-1.995l.04-.013-.01-.027c-.462-1.165-.65-2.272-.467-3.22l.016-.08c.15-.999.827-2.061 1.83-3.029.84-.81 1.839-1.468 2.489-1.66.208-.051.338-.11.395-.164.022-.02.022-.023.012-.043-.048-.095-.255-.23-.527-.34l-.016-.009c-.223-.118-.347-.21-.393-.306-.103-.22.078-.31.295-.307"
  }))));
};
export default SvgLoadMadkudu;